import { Reveal } from "./Reveal";
import { Linkedin, Mail, ArrowRight } from "lucide-react";

const LINKEDIN_URL = "https://www.linkedin.com/in/sanya-vithalkar/";
const EMAIL = "vithalkarsanya@gmail.com";

export const ContactCTA = () => {
  return (
    <section id="contact" data-testid="contact-section" className="relative bg-[#6B8F71] py-24 sm:py-36 text-[#FAF8F4] overflow-hidden">
      {/* drifting motif */}
      <div className="pointer-events-none absolute -top-10 -right-10 w-72 h-72 opacity-[0.12] animate-drift-slow">
        <svg viewBox="0 0 200 200" fill="none">
          <path d="M20,120 C60,60 140,60 180,120 C140,180 60,180 20,120 Z" stroke="#1A1A1A" strokeWidth="1" />
          <circle cx="100" cy="120" r="42" stroke="#1A1A1A" strokeWidth="1" />
        </svg>
      </div>

      <div className="max-w-6xl mx-auto px-6 sm:px-10 relative">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div>
            <Reveal>
              <p className="font-mono text-xs tracking-[0.32em] uppercase text-[#FAF8F4]">
                04 · Next step
              </p>
              <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] mt-5">
                Let's give your
                <br />
                system a form.
              </h2>
              <p className="font-sans text-base text-[#FAF8F4]/75 mt-6 max-w-md leading-relaxed">
                Hiring, collaborating, or just curious? Connect with me on
                LinkedIn or drop me an email. I read every message.
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <div className="flex flex-col gap-4 lg:items-end">
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="cta-linkedin"
                className="group inline-flex items-center gap-3 font-sans text-base px-7 py-4 rounded-full bg-[#FAF8F4] text-ink hover:bg-[#1A1A1A] hover:text-[#FAF8F4] transition-colors w-full sm:w-auto justify-center"
              >
                <Linkedin size={20} />
                Connect on LinkedIn
                <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
              </a>
              <a
                href={`mailto:${EMAIL}`}
                data-testid="cta-email"
                className="group inline-flex items-center gap-3 font-sans text-base px-7 py-4 rounded-full border border-[#FAF8F4]/40 text-[#FAF8F4] hover:border-[#C9A24B] hover:text-[#C9A24B] transition-colors w-full sm:w-auto justify-center"
              >
                <Mail size={20} />
                {EMAIL}
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
